var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { Button, Modal, ModalVariant, ButtonVariant, Checkbox } from '@patternfly/react-core';
const WarningModal = (_a) => {
    var { isOpen, onConfirm, onClose, children, confirmButtonLabel = 'Confirm', cancelButtonLabel = 'Cancel', variant = ModalVariant.small, titleIconVariant = 'warning', withCheckbox = false, checkboxLabel = 'I understand that this action cannot be undone', confirmButtonVariant = ButtonVariant.primary, ouiaId = 'WarningModal' } = _a, props = __rest(_a, ["isOpen", "onConfirm", "onClose", "children", "confirmButtonLabel", "cancelButtonLabel", "variant", "titleIconVariant", "withCheckbox", "checkboxLabel", "confirmButtonVariant", "ouiaId"]);
    const [checked, setChecked] = useState(false);
    return (React.createElement(Modal, Object.assign({ variant: variant, isOpen: isOpen, onClose: onClose, onEscapePress: onClose, titleIconVariant: titleIconVariant, actions: [
            React.createElement(Button, { ouiaId: `${ouiaId}-confirm-button`, key: "confirm", variant: confirmButtonVariant, onClick: () => {
                    onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm();
                    setChecked(false);
                }, isDisabled: withCheckbox && !checked }, confirmButtonLabel),
            React.createElement(Button, { ouiaId: `${ouiaId}-cancel-button`, key: "cancel", variant: ButtonVariant.link, onClick: onClose }, cancelButtonLabel),
        ], ouiaId: ouiaId }, props),
        children,
        withCheckbox ? (React.createElement(Checkbox, { isChecked: checked, onChange: (_event, value) => setChecked(value), label: checkboxLabel, id: "warning-modal-check", className: "pf-v5-u-mt-lg", ouiaId: `${ouiaId}-confirm-checkbox` })) : null));
};
export default WarningModal;
